import { action } from 'satcheljs';
import type { FolderForestTreeType } from 'owa-graph-schema';
import type ActionSource from '../store/schema/ActionSource';

export interface OnSelectFolderActionMessage {
    folderId: string;
    treeType: FolderForestTreeType;
    actionSource: ActionSource;
}
const defaultExport: (
    folderId: string,
    treeType: FolderForestTreeType,
    actionSource: ActionSource
) => OnSelectFolderActionMessage = action(
    'onSelectFolder',
    (
        folderId: string,
        treeType: FolderForestTreeType,
        actionSource: ActionSource
    ): OnSelectFolderActionMessage => ({
        folderId,
        treeType,
        actionSource,
    })
);
export default defaultExport;
